import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="0 0 32 32" {...props}><path d="M16 3c7.168 0 13 5.832 13 13s-5.832 13-13 13S3 23.168 3 16 8.832 3 16 3zm0 2C9.913 5 5 9.913 5 16s4.913 11 11 11 11-4.913 11-11S22.087 5 16 5zm-1 5h2v2h-2v-2zm0 4h2v8h-2v-8z" fill="#fff" /></svg>);